// extracted by mini-css-extract-plugin
module.exports = {"Header":"QrReader_Header__3JVEg","ScanCodeContainer":"QrReader_ScanCodeContainer__1xyfi","ScanCodeContainer__qrScanner":"QrReader_ScanCodeContainer__qrScanner__2OxLY"};